import script from "./h5pay.vue?vue&type=script&setup=true&lang=js"
export * from "./h5pay.vue?vue&type=script&setup=true&lang=js"

import "./h5pay.vue?vue&type=style&index=0&id=2702294e&lang=less"
import "./h5pay.vue?vue&type=style&index=1&id=2702294e&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/pay.7pa.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2702294e"]])

export default __exports__